export default "/images/heart.svg?b65bcc72103bb8c063ec3e8e5b37c5e4";